import { render, staticRenderFns } from "./vsevmesteProjList.vue?vue&type=template&id=baa67570&"
import script from "./vsevmesteProjList.vue?vue&type=script&lang=js&"
export * from "./vsevmesteProjList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports